export default [
    {
        id: 1,
        name: 'Capital de trabajo',
        alert: '< 0',
        unit: '$',
        formula: 'this.form.b.assets.total_current_assets - this.form.b.passives.total_current_passives',
        info:'Total activos corrientes - Total pasivos corrientes',
        restriction: null
    },
    {
        id: 2,
        name: 'Liquidez corriente',
        alert: '< 1',
        unit: 'Veces',
        formula: 'this.form.b.assets.total_current_assets / this.form.b.passives.total_current_passives',
        info:'Total activos corrientes / Total pasivos corrientes',
        restriction: null
    },
    {
        id: 3,
        name: 'Rotación Inventario',
        alert: '',
        unit: 'Días',
        formula: '30 * (this.form.b.assets.inventory / this.form.er.sales_costs)',
        info:'30 * ( Inventario / Costo de ventas )',
        restriction: null
    },
    {
        id: 4,
        name: 'Endeudamiento',
        alert: '> 100',
        unit: '%',
        formula: '(this.form.b.passives.total_business_passives/this.form.b.passives.patrimony)*100',
        info:'(Total pasivos del negocio / Patrimonio) * 100',
        restriction: null
    },
    {
        id: 5,
        name: 'Rentabilidad Negocio',
        alert: '< 0',
        unit: '%',
        formula: '(this.form.er.net_profit/this.form.er.account_sales)*100',
        info:'(Utilidad operativa / Ventas)',
        restriction: null
    },
    {
        id: 6,
        name: 'Rentabilidad Patrimonio',
        alert: '',
        unit: '%',
        formula: '(this.form.er.net_profit/this.form.b.passives.patrimony)*100',
        info:'(Utilidad operativa / Patrimonio)',
        restriction: null
    },
    {
        id: 7, //Solo Pequeña Empresa
        name: 'Capacidad de pago PE',
        alert: '> 75',
        unit: '%',
        formula:'(this.fm102quota/this.form.if.surplus)*100',
        info: '(Cuota mensual / Excedente)',
        restriction: 'PE'
    },
    {
        id: 8,
        name: 'Cobertura de la cuota',
        alert: '> 30',
        unit: '%',
        formula: '(this.form.if.expenses.credits/this.form.if.incomes.total)*100',
        info:'(Cuotas créditos recibidos por la unidad familiar / Total ingresos familiares)',
        restriction: null
    },
    {
        id: 9, //Solo Pequeña Empresa
        name: 'Apalancamiento',
        alert: '> 100',
        unit: '%',
        formula: '(this.form.b.passives.total_business_passives/this.form.b.assets.total_assets)*100',
        info:'(Total pasivo / Total activo)',
        restriction: 'PE'
    },
    {
        id: 10, //Solo Pequeña Empresa
        name: 'Margen de ventas',
        alert: '< 0',
        unit: '%',
        formula: '(this.form.er.gross_profit/form.er.account_sales)*100',
        info:'(Utilidad bruta / Total ventas)',
        restriction: 'PE'
    },
    
]
